const GrassrootCampaign = require('../classes/GrassrootCampaign');

module.exports = ["$q", "CTServiceAPI", "AppConstants", "AppLanguage", "CommitmentModel", "ChannelRepository", function($q, CTServiceAPI, AppConstants, AppLanguage, CommitmentModel, ChannelRepository) {
    const _service = this,
          _channel = ChannelRepository.get(AppConstants.CHANNEL_SUBMISSION.NAME);

    let _pageCache         = {},
        _campaignCache     = {},
        _cachedCommitments = {};


    /**
     * Get a specific campaign
     *
     * @param id
     * @return {Promise.<GrassrootCampaign>}
     */
    _service.getCampaign = (id, params = {}) => {
        if(!_campaignCache[id]) {
            _campaignCache[id] = CTServiceAPI.get(`/pages/${AppConstants.PAGE_ID}/grassroot_campaigns/${id}`, params)
                                             .then((data) => new GrassrootCampaign(data.grassroot_campaign));
        }

        return _campaignCache[id];
    };

    /**
     * Submit given data to the commitment module
     *
     * @param data
     * @param campaign
     */
    _service.submitCommitment = (data, campaign) => {
        if(AppLanguage !== false) {
            data.lang = AppLanguage.code;
            data.person.lang = AppLanguage.code;
        }
        
        let promise = CTServiceAPI.post(`/pages/${AppConstants.PAGE_ID}/grassroot_campaigns/${campaign.id}/people`, data);

        promise.then((submission) => {
            //TODO: Show story if moderation in ON
            if(submission.is_new) {
                _channel.notify(AppConstants.CHANNEL_SUBMISSION.ACTION_SUBMITTED, CommitmentModel(submission), 'item', 'commitment');
            }
        });

        return promise.then((submission) => ({
            // id       : submission.commitment_id,
            message  : data.message,
            image_url: data.image_url,
            image_id : data.image_id,
            person   : data.person,
            tags     : (data.tags || []).splice(0)
        }));
    };


    /**
     * Load the given page with the given page size
     *
     * @return {Promise.<T>}
     */
    _service.loadCampaignPage = (campaign/*, page_nr = 0, params = {}, page_size = 20*/) => {
        // const filter    = angular.extend({use_cache: AppConstants.USE_CACHE, fields: 'members'}, params, {page_nr, page_size}),
        const filter    = {
                  use_cache: AppConstants.USE_CACHE,
                  fields   : 'members'
              },
              _cacheKey = campaign.id;

        if(AppLanguage !== false) {
            filter.lang = AppLanguage.code;
        }

        if(!_pageCache[_cacheKey]) {
            _pageCache[_cacheKey] = CTServiceAPI.get(`/pages/${AppConstants.PAGE_ID}/grassroot_campaigns/${campaign.id}`, filter)
                                                .then((response) => {
                                                    var items = response.grassroot_campaign.people.map((item) => CommitmentModel(item));

                                                    if(AppConstants.RANDOMIZE) items = Array.shuffle(items);

                                                    delete _pageCache[_cacheKey];

                                                    return {
                                                        items,
                                                        total_count: items.length
                                                    };
                                                });
        }

        return _pageCache[_cacheKey];
    };


    /**
     * Return a single item
     *
     * @param id
     */
    _service.get = (id) => {
        if(!_cachedCommitments[id]) {
            _cachedCommitments[id] = CTServiceAPI.get(`/commitments/${AppConstants.COMMITMENT_PAGE_ID}/people/${id}`)
                                                 .then((response) => CommitmentModel(response.commitment_module_person));
        }

        return _cachedCommitments[id];
    };

    /**
     *
     * Get the next item id
     * @param forId
     */
    _service.getNextID = (forId) => $q((resolve, reject) => {
        let _items = _pageCache[forId] || [];

        var index;
        for(index = 0; index < _items.length; index++) {
            if(_items[index].id == forId) {
                if(!_items[index + 1]) return checkForId();

                return resolve(_items[index + 1].id);
            }
        }
        reject();
    });

    /**
     * Get the prev item id
     * @param forId
     */
    _service.getPreviousID = (forId) => $q((resolve, reject) => {
        let _items = [];

        var index;
        for(index = _items.length - 1; index >= 0; index--) {
            if(_items[index].id == forId) {
                if(!_items[index - 1]) return checkForId();

                return resolve(_items[index - 1].id);
            }
        }
        reject();
    });

    _service.updateCampaign = (id, data, auth_code) => {
        return CTServiceAPI({
            method: 'PUT',
            url   : `/pages/${AppConstants.PAGE_ID}/grassroot_campaigns/${id}`,
            params: {auth_code},
            data
        }).then((response) => response.grassroot_campaign);
    };

    return _service;
}];
